import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2e015f16&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/path0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e015f16')) {
      api.createRecord('2e015f16', component.options)
    } else {
      api.reload('2e015f16', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=2e015f16&", function () {
      api.rerender('2e015f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/App.vue"
export default component.exports